import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import AddButton from "../../AdminPanel/Component/UI/AddButton";
import DownloadButton from "../../AdminPanel/Component/UI/DownloadButton";
import CommonTable from "../../AdminPanel/Component/UI/CommonTable";
import SearchBox from "../../AdminPanel/Component/UI/SearchBox";
import Tooltip from "../../AdminPanel/Component/UI/Tooltip";
import AddUserModal from "./Component/AddUserModal";
import UpdateUserModal from "./Component/UpdateUserModal";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { LuUsers, LuDownload, LuCheck, LuUpload } from "react-icons/lu";
import { HiMiniPlus } from "react-icons/hi2";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import DeleteUserModal from "./Component/DeleteUserModal";
import moment from 'moment';
import { MdOutlineClose } from 'react-icons/md'
import { SheetJSFT } from "./Component/types";
import * as XLSX from "xlsx";
import UploadPreview from "./Component/UploadPreview";
import ProgressTab from "../Component/ProgressTab";


class AdminPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addUserModal: false,
      updateUserModal: false,
      showDeleteConfirmId: "",
      entries: 20,
      updateForm: {
        id: "",
        name: "",
        email: "",
        mobile: ""
      },
      pageNo: 1,
      size: 10,
      keyWord: "",
      activeTab: 1,
      formData: {
        "name": "",
        "email": "",
        "mobile": ""
      },
      showUploadPreview: false
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.getAvailableCodeCount());
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());

    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.getMyUserList(temp));
    this.callUserListAPI();
  }

  callUserListAPI = () => {
    const { pageNo, size, keyWord } = this.state;
    this.props.dispatch(
      assessmentActions.getMyUserList({
        pageNo,
        size,
        keyWord
      })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.pageNo !== this.state.pageNo ||
      prevState.size !== this.state.size ||
      prevState.keyWord !== this.state.keyWord
    ) {
      this.callUserListAPI();
    }
  }


  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getMyUserList(data));
  }

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getMyUserListTotal } = this.props.assessment;
    const totalPages = Math.ceil(getMyUserListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };

  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  openAddUserModal = () => {
    console.log("Opening Add User Modal");
    this.setState({ addUserModal: true }, () => {
      console.log("Modal state updated:", this.state.addUserModal);
    });
  };

  closeAddUserModal = () => {
    console.log("Closing Add User Modal");

    this.setState({
      addUserModal: false, formData: {
        "name": "",
        "email": "",
        "mobile": ""
      }
    });
  };

  handleEntriesChange = (value) => {
    this.setState({ entries: value });
  };

  onAddUser = () => {
    let { formData } = this.state;
    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    let data = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile
    }
    this.props.dispatch(assessmentActions.createMyUser(data, temp));
    this.closeAddUserModal();
  };

  handleUpdateChange = (e) => {
    let { updateForm } = this.state;
    updateForm[e.target.name] = e.target.value;
    this.setState({ updateForm });
  }

  handleReupload = () => {
    console.log("Reupload clicked");
    this.setState({ updateUserModal: false });
  };

  closeUpdateUserModal = () => {
    this.setState({ updateUserModal: false });
  };

  onEditUser = (data) => {
    let temp = {
      id: data.userId,
      name: data.name,
      email: data.email,
      mobile: data.mobile
    }
    this.setState({ updateForm: temp, updateUserModal: true });
  }

  onUpdateUser = (data) => {
    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.updateMyUser({ ...data, mobile: data.mobile.toString() }, temp));
    this.closeUpdateUserModal();
  };


  onDeleteConfirm = (row) => {
    this.setState({ showDeleteConfirmId: row.userId });
  };

  closeDeleteConfirm = () => {
    this.setState({ showDeleteConfirmId: "" });
  };


  submitDeleteConfirm = () => {
    let data = {
      id: this.state.showDeleteConfirmId
    }
    this.props.dispatch(assessmentActions.deleteMyUser(data));
    this.closeDeleteConfirm();
  };

  gotoProducts = () => {
    this.props.history.push(`/assessment/products`);
  };
  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };
  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  handleInputChange = (e) => {
    let { formData } = this.state;
    formData[e.target.name] = e.target.value;
    this.setState({ formData })
  }


  downLoadSampleCSV = () => {
    let binary_univers = [
      {
        mobile: "9999999999",
        email: "testuser001@mail.com",
        name: "TestUser001"
      },
    ];
    let binaryWS = XLSX.utils.json_to_sheet(binary_univers);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, binaryWS, "Binary values");
    XLSX.writeFile(wb, "sample users.xlsx");
  };

  handleTabClick = (value) => { this.setState({ activeTab: value }) };


  handleChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      this.setState({ fileUploadError: "No file selected!" });
      return;
    }

    const fileName = file.name.toLowerCase();
    const isValid = fileName.endsWith(".csv") || fileName.endsWith(".xlsx");

    if (!isValid) {
      this.setState({ fileUploadError: "Please upload csv or xlsx file!" });
      return;
    }

    this.setState({
      file,
      fileUploadError: "",
      loadedDataSheet: [],
      showUploadPreview: true,
      addUserModal: false
    });

    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);

    reader.onload = (event) => {
      const bstr = event.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
      });

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      let data = XLSX.utils.sheet_to_json(ws);

      data = data.map((row) => {
        let newRow = { ...row };
        Object.keys(newRow).forEach((key) => {
          const val = newRow[key];
          if (moment(val, ["MM/DD/YYYY", "MM/DD/YY"], true).isValid()) {
            newRow[key] = moment(val).format("DD-MM-YYYY");
          }
        });
        return newRow;
      });

      this.setState({
        loadedDataSheet: data,
        showEmployeeModal: false,
      });
    };
  };

  saveUploadEmployee = () => {
    const { loadedDataSheet } = this.state;
    if (loadedDataSheet.length > 0) {
      let temp = { keyWord: "", pageNo: 1, size: 10 }
      this.props.dispatch(
        assessmentActions.saveNewUserList(loadedDataSheet, temp)
      );
    }
  };
  closeUploadPreview = () => {
    this.setState({ showUploadPreview: false });
  }

  render() {
    let { assessment } = this.props;
    let { saveNewUserListData, userAssessmentUserProfileData, getMyUserListData, getMyUserListTotal, getAvailableCodeCountData } = assessment;
    const { showUploadPreview, formData, activeTab, addUserModal, updateUserModal, entries, showDeleteConfirmId } = this.state;

    let data = getMyUserListData && getMyUserListData.length > 0 ? getMyUserListData.map((ele, index) => ({
      id: index + 1,
      userId: ele.id,
      name: ele.name,
      email: ele.email,
      mobile: ele.mobile,
      role: "User",
    })) : [];

    const columns = [
      { key: "id", label: "S.No." },
      { key: "name", label: "Name" },
      { key: "email", label: "Email Address" },
      { key: "mobile", label: "Mobile" }
    ];

    const { pageNo, size } = this.state;
    const start = getMyUserListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getMyUserListTotal);
    const totalPages = Math.ceil(getMyUserListTotal / size);


    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };


    function getCodeCount(codeCountList = []) {
      let count = codeCountList && codeCountList.length > 0 ? (codeCountList
        .reduce((sum, item) => sum + (item.ordersCount || 0), 0)) : 0;
      return count > 0 ? count : 0
    }

    let { loading } = assessment;


    const tabs = [
      {
        id: 1,
        label: "Add employee manually",
        description: "Select users to create new employee.",
        icon: <LuUsers size={25} />,
      },
      {
        id: 2,
        label: "Add employees with file upload",
        description: "Upload a file to add many employees.",
        icon: <LuUpload size={25} />,
      },
    ];


    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="p-8 min-h-screen">
          <ProgressTab currentStep={2} history={this.props.history} />
          <div className="border-b border-slate-300" />

          <div className="flex items-center justify-between py-5">
            <div className="flex items-center gap-3">
              <Heading className="text-2xl font-bold text-gray-900" title="My Users" />
            </div>
            <div className="flex items-center gap-3">
              <AddButton title="Add New User" Icon={HiMiniPlus} className="bgcolor text-white" onClick={this.openAddUserModal} />
            </div>
          </div>

          {true ?
            <>
              <div className="overflow-x-auto bg-white border rounded-md p-4">
                <div className="flex justify-between items-center mb-4">
                  <div className="flex items-center gap-2 text-sm textblack">
                    Show
                    <select value={this.state.size} onChange={this.handleSizeChange} className="border rounded-md px-2 py-1">
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    entries
                  </div>

                  <div className="flex items-center gap-3 text-sm textblack">
                    <div className="">
                      <SearchBox
                        value={this.state.keyWord}
                        onChange={this.handleSearch}
                        placeholder="Search"
                      />
                    </div>
                    <div>{start}-{end} of {getMyUserListTotal}</div>
                    <div onClick={this.goPrev} disabled={this.state.pageNo === 1} className={`p-2 rounded-md ${this.state.pageNo === 1 ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                      <MdArrowBackIos size={20} />
                    </div>
                    <div onClick={this.goNext} disabled={this.state.pageNo === totalPages} className={`p-2 rounded-md ${this.state.pageNo === totalPages ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                      <MdArrowForwardIos size={20} />
                    </div>
                  </div>
                </div>

                <CommonTable
                  columns={columns}
                  data={data}
                  renderActions={(row) => (
                    <div className="flex gap-2">
                      <Tooltip text="Edit" position="top">
                        <div onClick={() => this.onEditUser(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-blue-100 hover:text-blue-600"><FiEdit size={18} /></div>
                      </Tooltip>
                      <Tooltip text="Delete" position="top">
                        <div onClick={() => this.onDeleteConfirm(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-red-100 hover:text-red-600 hover:bg-red-200"><RiDeleteBinLine size={18} /></div>
                      </Tooltip>
                    </div>
                  )}
                />


                {!loading && !(data && data.length > 0) &&
                  <div className="flex items-center justify-center">
                    <div className="text-center py-8">
                      <div className="flex flex-col items-center justify-center text-gray-500">
                        <h1 className="text-lg font-semibold">No Data Found</h1>
                        <p className="text-sm mt-1">Try adjusting your search or filters</p>
                      </div>
                    </div>
                  </div>
                }


              </div>
            </>
            :
            <>
              <div className="bg-gradient-to-b from-[#E3F2FD] to-white border rounded-xl min-h-[520px] flex flex-col items-center justify-center text-center space-y-6">
                <div className="w-20 h-20 rounded-full bg-white border-4 border-[#E0F2F1] flex items-center justify-center">
                  <AiOutlineUsergroupAdd size={40} className="textcolor" />
                </div>
                <div className="space-y-1">
                  <h3 className="text-lg font-semibold">Add your first user to continue.</h3>
                  <p className="text-sm textlight">You can add users manually or upload a list.</p>
                </div>
                <AddButton title="Add New User" Icon={HiMiniPlus} className="bgcolor text-white" onClick={this.openAddUserModal} />
              </div>

            </>}

        </div>

        <div className="sticky bottom-0 left-0 right-0 bg-white/90 backdrop-blur-md border-t border-gray-200 py-4 px-6 flex items-center justify-between z-10">
          <button onClick={() => this.props.history.goBack()} className="px-8 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-500 font-semibold text-base transition-colors duration-200">  Back</button>
          <button onClick={() => this.props.history.push("/assessment/myteams")} className="px-5 py-2 rounded-md bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white font-semibold text-base transition-colors duration-200 shadow-md shadow-indigo-100">  Continue to Step 3</button>
        </div>

        {addUserModal ? (
          <div className="fixed top-0 right-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-40 xl:h-screen">
            <div className="w-11/12 mx-auto bg-white rounded-lg shadow-sm xl:w-6/12 lg:w-9/12 ">
              {/* head */}
              <div className="flex items-center justify-between p-4 border-b md:px-8 ">
                <h2 className="text-lg font-semibold md:text-xl test-gray-800">Add Users</h2>
                <div onClick={() => this.closeAddUserModal()} className="p-2 rounded-full cursor-pointer bg-slate-100 hover:bg-slate-200 ">
                  <MdOutlineClose size={22} className="textblack" />
                </div>
              </div>

              <nav className="flex gap-6 md:px-8 px-4 mt-5" aria-label="Tabs">
                {tabs.map((tab) => {
                  const isActive = activeTab === tab.id;

                  return (

                    <button
                      key={tab.id}
                      onClick={() => this.handleTabClick(tab.id)}
                      className={`flex items-center justify-between w-full max-w-md p-4 rounded-lg border transition-all duration-200 ${isActive
                        ? "border-indigo-500 bg-gradient-to-r from-indigo-100 to-white"
                        : "border-gray-300 bg-white hover:border-indigo-400"
                        }`}
                    >
                      <div className="flex items-center md:gap-3 gap-2">
                        <div className={`text-xl shrink-0 ${isActive ? "text-indigo-600" : "text-gray-500"}`}>{tab.icon}</div>
                        <div className="text-left">
                          <p className="text-sm font-semibold text-gray-800">{tab.label}</p>
                          <p className="text-xs text-gray-500">{tab.description}</p>
                        </div>
                      </div>
                      <div
                        className={`flex items-center justify-center w-6 h-6 p-0.5 rounded-full border ${isActive
                          ? "bg-indigo-600 border-indigo-600 text-white"
                          : "border-gray-400 text-transparent"
                          }`}
                      >
                        <LuCheck size={22} />
                      </div>
                    </button>
                  );
                })}
              </nav>

              {activeTab === 1 ?
                <>
                  <div className="space-y-4 md:px-8 px-4 py-6">
                    <div className="space-y-1">
                      <label className="block textblack text-sm font-medium">Enter Name</label>
                      <input
                        name="name"
                        placeholder="Enter Name"
                        value={formData.name || ""}
                        onChange={this.handleInputChange}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                      />
                    </div>
                    <div className="space-y-1">
                      <label className="block textblack text-sm font-medium">Enter Email</label>
                      <input
                        name="email"
                        placeholder="Enter Email"
                        value={formData.email || ""}
                        onChange={this.handleInputChange}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                      />
                    </div>
                    <div className="space-y-1">
                      <label className="block textblack text-sm font-medium">Enter Mobile No</label>
                      <input
                        name="mobile"
                        placeholder="Enter Mobile No"
                        value={formData.mobile || ""}
                        onChange={this.handleInputChange}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none transition-all"
                      />
                    </div>

                    {/* Footer */}
                    <div className="flex justify-end gap-3 py-4 mt-2">
                      <div className="flex items-center justify-end gap-3">
                        <button onClick={() => this.closeAddUserModal()} className="px-6 py-2 text-base font-semibold text-gray-900 bg-white border border-gray-300 rounded-md active:scale-95 transition-all">Cancel</button>
                      </div>
                      <div className="flex items-center justify-end gap-3">
                        <button onClick={() => this.onAddUser()} className="px-6 py-2 text-base font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 active:scale-95 transition-all">Create</button>
                      </div>
                    </div>
                  </div>
                </>
                : null}

              {activeTab === 2 ?
                <>
                  <div className="m-4 space-y-8 md:m-8 h-[26rem] overflow-y-auto">
                    {/* data here */}
                    <div className="p-4 space-y-2 text-sm border divide-y rounded-md text-slate-800">
                      <h1 className="text-lg font-semibold text-slate-800 ">
                        {" "}
                        Guidelines for uploading the data
                      </h1>
                      <ol className="list-disc pl-6 space-y-1.5 py-4 text-slate-800 ">
                        <li className="">
                          {" "}
                          Mandatory Column include email as first
                          column & second column should be in the file.
                        </li>
                        <li className="capitalize">
                          {" "}
                          Your file columns/headers should not contain any
                          special characters – this includes characters that
                          are not numbers or the English alphabet.
                        </li>
                        <li className="capitalize">
                          {" "}
                          Be careful not to include duplicates of the same
                          row – no two employees should have the same email.
                        </li>
                        <li className="capitalize">
                          {" "}
                          Date format must be same as DD-MM-YYYY
                        </li>
                        <li className="capitalize">
                          {" "}
                          See the sample data format for reference and
                          prepare your master data accordingly without any
                          change in mandatory column names
                        </li>
                        <li className="capitalize">
                          {" "}
                          Make sure your Excel sheet is not password
                          protected.
                        </li>
                      </ol>
                    </div>

                    <div className="space-y-4">
                      <div className="grid grid-cols-1 gap-4 xl:grid-cols-4 md:grid-cols-2">
                        {/* 1 */}
                        <div
                          onClick={() => this.downLoadSampleCSV()}
                          className="flex items-start p-2 px-4 space-x-4 rounded shadow-sm cursor-pointer 2xl:items-center bg-indigo-100 md:col-span-2"
                        >
                          <span class="material-symbols-outlined p-2 bg-white rounded-full text-indigo-600 shadow-sm">
                            download
                          </span>
                          <div>
                            <h1 className="text-sm font-medium md:text-base text-slate-800 ">
                              Download Sample Data
                            </h1>
                            <p className="text-sm text-gray-500">
                              See the sample data format for reference
                            </p>
                          </div>
                        </div>

                        {/* 2 */}
                        <input
                          type="file"
                          id="file"
                          accept={SheetJSFT}
                          onChange={this.handleChange}
                          hidden
                        />
                        <label
                          for="file"
                          className="rounded shadow-sm cursor-pointer bg-indigo-100 md:col-span-2"
                        >
                          <div className="flex items-start p-2 px-4 space-x-4 2xl:items-center ">
                            <span class="material-symbols-outlined p-2 bg-white rounded-full text-indigo-600 shadow-sm">
                              upload
                            </span>
                            <div>
                              <h1 className="text-sm font-medium md:text-base text-slate-800 ">
                                Upload Master Data
                              </h1>
                              <p className="text-sm text-gray-500">
                                Upload master data as per the guidelines
                              </p>
                            </div>
                          </div>
                        </label>
                      </div>

                      <div className="hidden">
                        <button
                          onClick={() => this.downLoadSampleCSV()}
                          className=" border border-green-500 rounded-md px-6 py-1.5 text-xs text-green-500 focus:outline-none"
                        >
                          Sample CSV
                        </button>

                        <button
                          onClick={this.handleFile}
                          className="ml-22 border border-indigo-500 rounded-md px-6 py-1.5 text-xs text-indigo-600 focus:outline-none"
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </>
                : null}

            </div>
          </div>
        ) : null}

        {showUploadPreview ? (
          <>
            <UploadPreview
              loadedDataSheet={this.state.loadedDataSheet}
              closeUploadPreview={this.closeUploadPreview}
              saveUploadEmployee={this.saveUploadEmployee}
              handleChange={this.handleChange}
              SheetJSFT={SheetJSFT}
              saveEmpList={saveNewUserListData}
              crrFieldType={[]}
            />
          </>
        ) : null}



        {/* {addUserModal && (
          <AddUserModal onClose={this.closeAddUserModal} onSubmit={this.onAddUser} />
        )} */}

        {updateUserModal && (
          <UpdateUserModal onClose={this.closeUpdateUserModal} updateForm={this.state.updateForm} handleUpdateChange={this.handleUpdateChange} onSubmit={this.onUpdateUser} />
        )}

        {showDeleteConfirmId && (
          <DeleteUserModal onClose={this.closeDeleteConfirm} onSubmit={this.submitDeleteConfirm}
          />
        )}

      </Dashboard>
    );
  }
}


function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { assessment } = state;
  return {
    loggingIn,
    assessment
  };
}

export default connect(mapStateToProps)(AdminPanel);
